import React, { FC, useMemo, useRef, useState } from 'react';

import { DropDownOptions } from 'devextreme-react/cjs/select-box';
//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, SelectBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import { useLazyRequestWorkMixerReportQuery } from 'bus/request';
import { RequestMixerReport } from 'bus/request/types';

type Props = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
};

const initialForm: RequestMixerReport = {
  dateBegin: undefined,
  dateEnd: undefined,
  transportId: 0,
};

const ReportModal: FC<Props> = ({ changeVisible, visible }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<RequestMixerReport>(initialForm);

  const storeTransport: any = useMemo(() => {
    const defaultFilter = ['transportType', '=', '1'];
    return $createDataSource('/v1/Transport', 'id', { defaultFilter });
  }, []);

  const onHidden = () => {
    createGroupValidationRef.current?.instance.reset();
    setForm(initialForm);
  };

  const [requestWorkMixerReport, { isLoading }] = useLazyRequestWorkMixerReportQuery();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      await requestWorkMixerReport({ ...form });
      changeVisible(false);
    }
  };

  const handleHideModal = () => {
    changeVisible(false);
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={handleHideModal}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Отчет отгрузок"
        width={400}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Дата начала" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, dateBegin: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.dateBegin}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата начала" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <AppFiledBox label="Дата окончания" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, dateEnd: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.dateEnd}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата окончания" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>

                        <AppFiledBox label="Транспорт" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeTransport}
                            displayExpr="fullName"
                            valueExpr="id"
                            value={form.transportId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, transportId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Транспорт" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Транспорт" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={handleHideModal}
                  disabledSubmit={isLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default ReportModal;
